export const SET_COUNTRIES = "config/SET_COUNTRIES";
export const SET_DATA = "config/SET_DATA";
export const SET_PUBLIC_IP_ADDRESS_DETAILS =
  "config/SET_PUBLIC_IP_ADDRESS_DETAILS";
